/**
 * Reads a cookie by name from `document.cookie`. Returns the raw decoded
 * value, or `undefined` if missing / not in a browser context.
 *
 * Handles `%` escaping and quoted values per the cookie spec.
 */
export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined' || !name) return undefined

  const cookies = document.cookie ? document.cookie.split('; ') : []
  for (const raw of cookies) {
    const eq = raw.indexOf('=')
    if (eq < 0) continue
    const key = raw.slice(0, eq)
    const value = raw.slice(eq + 1)
    try {
      if (decodeURIComponent(key) === name) {
        return readCookie(value)
      }
    } catch {
      // Skip malformed entries.
    }
  }
  return undefined
}

function readCookie(value: string): string {
  const unquoted = value.startsWith('"') && value.endsWith('"') ? value.slice(1, -1) : value
  return unquoted.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
}
